<template>
  <div v-if="clients" class="custom-modal text-primary">
    <div class="custom-modal-header">
      <div class="close-modal">
        <i class="bx bx-x" @click="closeModal"></i>
      </div>
      <div class="title">
        <h5>Alerts</h5>
      </div>
    </div>
    <div class="modal-body">
      <b-form-checkbox v-model="filterTasks" switch @input="toggleNotifications">
        TASKS
      </b-form-checkbox>
      <div v-for="(notification, key) in notifications" v-bind:key="key">
        <div class="thumbnail-row-container">
          <div @click="redirect(notification)"  class="notification-modal">
            <div class="row-indicator">
              <span v-html="notification.attributes.isUnread ? '&#8226;' : ''"></span>
            </div>
            <div class="row-thumbnail">
              <div v-if="notificationUser(notification.attributes.data.userId, 'thumbnailUrl')">
                <img v-bind:src="notificationUser(notification.attributes.data.userId, 'thumbnailUrl')">
              </div>
              <div v-else class="initials">
                {{ notificationUser(notification.attributes.data.userId, 'initials') }}
              </div>
            </div>
            <div class="row-main">
              <p><span>{{ notificationUser(notification.attributes.data.userId, 'firstName') }}</span><br>{{ notification.attributes.data.title }}</p>
            </div>
            <div>
              <p>{{ notification.attributes.timeAgo }}</p>
            </div>
          </div>
        </div>
        <button v-if="filterTasks" class="btn btn-sm btn-outline-light" @click="update(notification, 'isComplete')"><i class="fa fa-check"></i></button>
      </div>
    </div>
  </div>
</template>
<script>
import { bus } from '@/main'
import api from '@/services/api'
import 'vue2-datepicker/index.css'

export default {
  name: 'notifications',
  data () {
    return {
      notifications: {},
      allNotifications: {},
      taskNotifications: {},
      filterTasks: false
    }
  },
  methods: {
    redirect (notification) {
      this.update(notification, 'isRead', true)
    },
    update (notification, type, redirect = false) {
      return api.put('/api/stylist/notifications/' + notification.id, {
        type: type
      }).then(response => {
        this.processNotifications(response.data.data)
        if (redirect) {
          const data = {
            userId: notification.attributes.data.userId,
            url: notification.attributes.data.webUrl
          }
          this.$store.dispatch('authenticateAndRedirect', data)
        }
      })
    },
    getNotifications () {
      return api.get('/api/stylist/notifications').then(response => {
        this.processNotifications(response.data.data)
      })
    },
    notificationUser (userId, attribute) {
      if (!userId) {
        return
      }
      if (userId === parseInt(this.$store.state.stylist.id)) {
        return this.$store.state.stylist[attribute]
      }
      return this.clients.filter(client => Number(client.id) === userId)[0][attribute]
    },
    toggleNotifications () {
      if (this.filterTasks) {
        this.notifications = this.taskNotifications
        return
      }
      this.notifications = this.allNotifications
    },
    processNotifications (response) {
      this.allNotifications = this.notifications = response
      this.taskNotifications = this.notifications.filter(notification => notification.attributes.data.isTask === true)
      this.$store.dispatch('taskCount', this.taskNotifications.length)
      let unreadNotifications = 0
      this.notifications.forEach(notification => {
        if (notification.attributes.isUnread) {
          unreadNotifications++
        }
      })
      this.$emit('unreadNotifications', unreadNotifications)
    },
    closeModal () {
      this.$bvModal.hide('notifications-modal')
    }
  },
  mounted () {
    if (this.$store.state.stylist) {
      this.getNotifications()
    }
  },
  computed: {
    clients () {
      return this.$store.state.clients
    }
  },
  created () {
    bus.$on('updatedNotifications', (isUpdated) => {
      if (isUpdated) {
        this.getNotifications()
      }
    })
  }
}
</script>
